module.exports = __webpack_public_path__ + "assets/b81.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b81.png
// module id = 673
// module chunks = 0